import React from 'react'

const SectionHeading = ({title}) => {
  return (
    <div style={{color:'black'}} className='d-flex my-5 Ethnocentric' ><span className='vertical-design'></span> <h4 className=''>{title}</h4></div>
  )
}

export default SectionHeading